// Test if `text` has a match in the `regexList`.
const testSome = (regexList, text) => regexList.some((rx) => rx.test(text));

export default testSome;
